import { Obu } from '_lib/api';

export const transformObuObjectToArray = (obuObject: Record<string, string>): Obu[] => {
  return Object.entries(obuObject).map(([id, name]) => ({ id, name }));
};
